
export const getCookie = name => {
    let nameEQ = name + "=";
    // Split document.cookie on semicolons into an array and find the desired cookie
    let cookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith(nameEQ));
    // If the cookie is found, return its value
    return cookie ? cookie.trim().substring(nameEQ.length) : null;
}

export const removeCookie = (name, path = '/') => {
    document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT; secure; SameSite=Strict`;
}